<template>
    <span v-if="row.relay_id">
        <router-link
            tag="a"
            :to="`/${organizationSlug}/relays/${row.relay_id}/details/${row.serial_number}`"
            class="view icon-view"
            title="details"
        />
    </span>
</template>

<script>
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import canToast from '@/mixins/canToast'

export default {
    components: {},

    mixins: [canToast, needsOrganizationSlug],

    props: {
        row: {
            type: Object,
            required: true,
        },
    },
}
</script>
